import { GlobalViewState } from './partials/global_view'
import { UserGroupState } from './partials/user_groups'
import { UserNewsState } from './partials/news'
import { UserProfileState } from './partials/user-profile'
import { UserTeamsState } from './partials/teams'

export const UserState = _ => ({
  ...GlobalViewState,
  ...UserGroupState,
  ...UserNewsState,
  ...UserProfileState,
  ...UserTeamsState,
})
